import React, { Component } from 'react';
import { compose } from 'redux';
import { objectOf, any, func } from 'prop-types';
import className from 'classnames';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
// import moment from 'moment';
import { withFormik } from 'formik';
import { noop, get, isEmpty, values as mapValues } from 'lodash';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { RadioButton, Modal } from 'homecredit-ui';
import Input from 'components/common/Input';
// import DatePicker from 'components/common/DatePicker';
import Button from 'components/common/Button';
import {
  updateUserInformation,
  generateOTP,
  showErrorNotification,
} from 'actions/clz/0bod';
import { MESSAGE } from 'constants/internal';
import FullLoading from 'components/common/FullLoading/FullLoading';
import Cycle from 'components/common/FullLoading/Cycle';
import { verifySACode } from 'actions/sale';
import { sendGACustom, sendGAEvent } from 'utils/ga';
import CredoUtils from 'utils/credo';
import { debounce, extractFullName, getCookie, setCookie } from 'utils/helpers';

// import { clearClxPrefillInfo, getClxPrefillInfo } from 'utils/sessionStorage';
import InputDate from 'components/common/InputDateTime';
import s from './style.css';
import { informationValidation, readyFormSubmit } from './validate';
import infoIcon from '../images/info-icon.svg';
import {
  FORM_FIELDS,
  GENDER_FEMALE,
  GENDER_MALE,
  initialValue,
  SA_CODE_KEY_COOKIE,
  SA_CODE_STORE_MAX_AGE,
} from './constant';
import { STEP_NAME, STEPS } from '../constant';

const FullLoadingCycle = FullLoading(Cycle);

class PersonalInformation extends Component {
  static propTypes = {
    values: objectOf(any),
    newBOD: objectOf(any),
    errors: objectOf(any),
    goToNextStep: func,
    updatePersonalInformation: func,
    handleChange: func,
    bodGenerateOTP: func,
    touched: objectOf(any),
    params: objectOf(any),
    setFieldValue: func,
    setFieldTouched: func,
    handleBlur: func,
  };

  static defaultProps = {
    values: {},
    touched: {},
    errors: {},
    params: {},
    newBOD: {},
    goToNextStep: noop,
    handleChange: noop,
    bodGenerateOTP: noop,
    updatePersonalInformation: noop,
    setFieldValue: noop,
    setFieldTouched: noop,
    handleBlur: noop,
  };
  state = {
    gender: '',
    birthday: '',
    isOpenPolicy: false,
    loading: false,
  };

  async componentDidMount() {
    const { params, newBOD, setFieldValue } = this.props;
    const saCode = get(newBOD, 'saInformation.saCode');
    const existingSaCode = getCookie(SA_CODE_KEY_COOKIE);
    const saCodeInput = saCode || existingSaCode || '';
    !!saCode &&
      setCookie(SA_CODE_KEY_COOKIE, saCode, {
        secure: true,
        'max-age': SA_CODE_STORE_MAX_AGE,
      });

    if (get(params, 'sa', '') !== STEP_NAME[STEPS.START_LOAN]) {
      this.updateInitialForm();
    }
    setFieldValue(FORM_FIELDS.HOME_ID, saCodeInput);
    // this.prefillDataFromCLX();
    sendGAEvent('Visit_Page', 'Basic_Info_Page', 'ACL_0BOD_Basic_Info');
    await CredoUtils.startChecking();
  }

  onChangeGender = e => {
    sendGAEvent(
      `Select_Gender_${e}_Option`,
      `Gender_${e}_Option`,
      'ACL_0BOD_Basic_Info',
    );
    this.setState({ gender: e });
  };

  onChangeBirthday = value => {
    const { setFieldValue, setFieldTouched } = this.props;
    setFieldValue(FORM_FIELDS.BIRTHDAY, value);
    setFieldTouched(FORM_FIELDS.BIRTHDAY, true);
    this.setState({ birthday: value });
  };

  onSubmitInformation = async e => {
    e.preventDefault();
    this.setState({ loading: true });
    const { document, birthday, gender } = this.state;
    const {
      validateForm,
      values: formValues,
      updatePersonalInformation,
      goToNextStep,
      bodGenerateOTP,
      toggleAlert,
    } = this.props;
    const errors = await validateForm();
    if (isEmpty(errors)) {
      if (formValues[FORM_FIELDS.HOME_ID]) {
        const saCodeResult = await verifySACode(
          formValues[FORM_FIELDS.HOME_ID],
        );
        if (!saCodeResult || !saCodeResult.valid) {
          this.setState({ loading: false });
          return toggleAlert(MESSAGE.SACODE_INCORRECT);
        }
        sendGACustom(2, 'sa_support');
      } else sendGACustom(2, 'no_sa_support');
      const info = {
        ...formValues,
        [FORM_FIELDS.MONTHLY_INCOME]: this.preNumberFormat(
          formValues[FORM_FIELDS.MONTHLY_INCOME],
        ),
        [FORM_FIELDS.BIRTHDAY]: birthday,
        [FORM_FIELDS.GENDER]: gender,
        [FORM_FIELDS.DOCUMENT]: document,
        result: '',
      };
      updatePersonalInformation(info);
      /* eslint-disable no-undef */
      const google = get(window, 'App.google');
      const siteKey = get(google, 'recaptcha.siteKey');
      grecaptcha.ready(async () => {
        const token = await grecaptcha.execute(siteKey, { action: 'submit' });
        const data = await bodGenerateOTP(info[FORM_FIELDS.PHONENUMBER], token);
        data && goToNextStep();
        this.setState({ loading: false });
      });

      sendGAEvent(
        'Tap_Continue_Button',
        'Continue_Button',
        'ACL_0BOD_Basic_Info',
      );
    }
    return formValues;
  };

  onToggleOpenPolicy = () => {
    const { isOpenPolicy } = this.state;
    this.setState({ isOpenPolicy: !isOpenPolicy });

    if (isOpenPolicy)
      return sendGAEvent(
        'Tap_Continue_With_TnC_Button',
        'Continue_TnC_Button_Button',
        'ACL_0BOD_Basic_Info',
      );

    return sendGAEvent(
      'Tap_TnC_Information_Button',
      'TnC_Information_Button',
      'ACL_0BOD_Basic_Info',
    );
  };

  onBlur = name => e => {
    const { setFieldValue, handleBlur } = this.props;
    setFieldValue(name, e.target.value.trim());
    handleBlur(e);
  };

  updateInitialForm = () => {
    const { newBOD, setFieldValue } = this.props;
    const user = get(newBOD, 'user', undefined);
    if (user) {
      mapValues(FORM_FIELDS).forEach(value => {
        if (value) {
          if (value === FORM_FIELDS.GENDER)
            this.setState({ gender: user[FORM_FIELDS.GENDER] });
          if (value === FORM_FIELDS.BIRTHDAY)
            this.setState({ birthday: user[FORM_FIELDS.BIRTHDAY] });
          setFieldValue(value, user[value]);
        }
      });
    }
  };

  // prefillDataFromCLX = () => {
  //   const {
  //     newBOD: { utm = '' },
  //     setFieldValue,
  //   } = this.props;
  //   if (utm && utm.includes('utm_source=CLXWeb')) {
  //     const clxInfo = getClxPrefillInfo();
  //     if (clxInfo) {
  //       setFieldValue(FORM_FIELDS.PHONENUMBER, clxInfo?.phoneNumber || '');
  //       setFieldValue(FORM_FIELDS.MONTHLY_INCOME, clxInfo?.income || '');
  //       clearClxPrefillInfo();
  //     }
  //   }
  // };
  preNumberFormat = (v = '') => v && `${v}`.replace(/\./g, '').trim();

  handleFullName = e => {
    const { handleChange, setFieldValue } = this.props;
    const { value } = e.target;
    handleChange(e);
    debounce(() => {
      const [lastName, middleName, firstName] = extractFullName(value);
      setFieldValue(FORM_FIELDS.FIRST_NAME, firstName);
      setFieldValue(FORM_FIELDS.MIDDLE_NAME, middleName);
      setFieldValue(FORM_FIELDS.LAST_NAME, lastName);
    }, 300)();
  };

  render() {
    const {
      handleChange,
      handleBlur,
      values: formValues,
      touched,
      errors,
      newBOD,
    } = this.props;
    const saCode = get(newBOD, 'saInformation.saCode');
    const { birthday, gender, isOpenPolicy, loading } = this.state;
    const isMale = gender === GENDER_MALE;
    const isFemale = gender === GENDER_FEMALE;
    const isReadyForm =
      gender &&
      !errors[FORM_FIELDS.BIRTHDAY] &&
      readyFormSubmit(formValues, errors);
    return (
      <div className="container">
        <div className={s.container}>
          <img
            src="images/song-vui-3x.png"
            className={s.logo}
            alt="Sống vui cùng HomeCredit"
          />
          <form className={s.form} onSubmit={this.onSubmitInformation}>
            <div className={s.info}>
              <p className={s.title}>Thông tin cơ bản</p>
              <Input
                label="Tên đầy đủ"
                value={formValues[FORM_FIELDS.FULL_NAME]}
                touched={touched}
                onChange={this.handleFullName}
                errorMsg={
                  touched[FORM_FIELDS.FULL_NAME] &&
                  errors[FORM_FIELDS.FULL_NAME]
                }
                require
                name={FORM_FIELDS.FULL_NAME}
                className={s.input}
                onBlur={this.onBlur(FORM_FIELDS.FULL_NAME)}
                popoverPosition="left"
                touch={() =>
                  sendGAEvent(
                    'Tap_Full_Name_Textbox',
                    'Full_Name_Textbox',
                    'ACL_0BOD_Basic_Info',
                  )
                }
              />
              {/* <Input
                label="Họ"
                value={formValues[FORM_FIELDS.LAST_NAME]}
                touched={touched}
                onChange={handleChange}
                errorMsg={
                  touched[FORM_FIELDS.LAST_NAME] &&
                  errors[FORM_FIELDS.LAST_NAME]
                }
                require
                name={FORM_FIELDS.LAST_NAME}
                className={s.input}
                onBlur={this.onBlur(FORM_FIELDS.LAST_NAME)}
                popoverPosition="left"
                touch={() =>
                  sendGAEvent(
                    'Tap_Last_Name_Textbox',
                    'Last_Name_Textbox',
                    'ACL_0BOD_Basic_Info',
                  )
                }
              />
              <Input
                label="Tên đệm (Tên lót)"
                value={formValues[FORM_FIELDS.MIDDLE_NAME]}
                touched={touched}
                onChange={handleChange}
                onBlur={this.onBlur(FORM_FIELDS.MIDDLE_NAME)}
                name={FORM_FIELDS.MIDDLE_NAME}
                errorMsg={errors[FORM_FIELDS.MIDDLE_NAME]}
                className={s.input}
                popoverPosition="left"
                touch={() =>
                  sendGAEvent(
                    'Tap_Middle_Name_Textbox',
                    'Middle_Name_Textbox',
                    'ACL_0BOD_Basic_Info',
                  )
                }
              />
              <Input
                label="Tên"
                value={formValues[FORM_FIELDS.FIRST_NAME]}
                touched={touched}
                onChange={handleChange}
                onBlur={this.onBlur(FORM_FIELDS.FIRST_NAME)}
                require
                name={FORM_FIELDS.FIRST_NAME}
                errorMsg={
                  touched[FORM_FIELDS.FIRST_NAME] &&
                  errors[FORM_FIELDS.FIRST_NAME]
                }
                className={s.input}
                popoverPosition="left"
                touch={() =>
                  sendGAEvent(
                    'Tap_First_Name_Textbox',
                    'First_Name_Textbox',
                    'ACL_0BOD_Basic_Info',
                  )
                }
              /> */}
              <Input
                type="tel"
                label="Số điện thoại"
                touched={touched}
                value={formValues[FORM_FIELDS.PHONENUMBER]}
                onChange={handleChange}
                onBlur={handleBlur}
                require
                name={FORM_FIELDS.PHONENUMBER}
                maxLength={10}
                errorMsg={
                  touched[FORM_FIELDS.PHONENUMBER] &&
                  errors[FORM_FIELDS.PHONENUMBER]
                }
                popoverPosition="left"
                className={s.input}
                touch={() =>
                  sendGAEvent(
                    'Tap_Phone_Textbox',
                    'Phone_Textbox',
                    'ACL_0BOD_Basic_Info',
                  )
                }
              />
              <div className={s.gender}>
                <RadioButton
                  label="Nam"
                  value={GENDER_MALE}
                  name={FORM_FIELDS.GENDER}
                  onChange={this.onChangeGender}
                  checked={isMale}
                  className={className(s.radio, isMale && s.active)}
                />
                <RadioButton
                  label="Nữ"
                  value={GENDER_FEMALE}
                  name={FORM_FIELDS.GENDER}
                  onChange={this.onChangeGender}
                  checked={isFemale}
                  className={className(s.radio, isFemale && s.active)}
                />
              </div>
              {/* <DatePicker
                label="Ngày tháng năm sinh"
                name={FORM_FIELDS.BIRTHDAY}
                value={birthday}
                onChange={this.onChangeBirthday}
                maxDate={moment().subtract(20, 'y')}
                minDate={moment()
                  .subtract(60, 'y')
                  .subtract(364, 'd')}
                dateFormat="YYYY-MM-DD"
                displayFormat="DD / MM / YYYY"
                isNative
              /> */}
              <InputDate
                type="number"
                className={s.input}
                onChangeParent={this.onChangeBirthday}
                required
                initialValues={birthday}
                errMess={
                  touched[FORM_FIELDS.BIRTHDAY] && errors[FORM_FIELDS.BIRTHDAY]
                }
              />
              <Input
                type="tel"
                isNumber
                preFormat={this.preNumberFormat}
                numberFormat="de-DE"
                label="Thu nhập hàng tháng"
                value={this.preNumberFormat(
                  formValues[FORM_FIELDS.MONTHLY_INCOME],
                )}
                touched={touched}
                errorMsg={
                  touched[FORM_FIELDS.MONTHLY_INCOME] &&
                  errors[FORM_FIELDS.MONTHLY_INCOME]
                }
                onChange={handleChange}
                maxLength={11}
                onBlur={handleBlur}
                require
                name={FORM_FIELDS.MONTHLY_INCOME}
                popoverPosition="left"
                className={s.input}
                touch={() =>
                  sendGAEvent(
                    'Tap_Income_Textbox',
                    'Income_Textbox',
                    'ACL_0BOD_Basic_Info',
                  )
                }
              />
              <Input
                label="Mã nhân viên Homecredit (không bắt buộc)"
                value={formValues[FORM_FIELDS.HOME_ID]}
                onChange={handleChange}
                name={FORM_FIELDS.HOME_ID}
                className={s.input}
                disabled={!!saCode}
                touch={() =>
                  sendGAEvent(
                    'Tap_SA_Code_Textbox',
                    'SA_Code_Textbox',
                    'ACL_0BOD_Basic_Info',
                  )
                }
              />
            </div>
            <div className={s.info}>
              <p className={s.title}>Giấy tờ cá nhân</p>
              <Input
                isNumber
                label="Số CCCD / Căn cước"
                preFormat={this.preNumberFormat}
                value={formValues[FORM_FIELDS.ID_CARD]}
                touched={touched}
                errorMsg={
                  touched[FORM_FIELDS.ID_CARD] && errors[FORM_FIELDS.ID_CARD]
                }
                onChange={handleChange}
                onBlur={handleBlur}
                require
                name={FORM_FIELDS.ID_CARD}
                popoverPosition="left"
                className={s.input}
                touch={() =>
                  sendGAEvent(
                    'Tap_ID_Textbox',
                    'ID_Textbox',
                    'ACL_0BOD_Basic_Info',
                  )
                }
              />
            </div>
            <a className={s.policy} onClick={this.onToggleOpenPolicy}>
              <img src={infoIcon} alt="home documents" />
              <p>
                Bằng cách nhấn ‘Kiểm tra ngay’, tôi đã đồng ý những điều khoản
                và điều kiện
              </p>
            </a>
            <Button
              disabled={!isReadyForm}
              className={s.btnStart}
              type="submit"
            >
              Kiểm tra ngay
            </Button>
          </form>
        </div>
        <Modal
          isOpen={isOpenPolicy}
          onClose={this.onToggleOpenPolicy}
          className={s.modal}
        >
          <div className={s.modalContent}>
            <p className={s.modalTitle}>Điều khoản và điều kiện</p>
            <div className={s.modalItem}>
              <p className={s.modalItemDesc}>
                Bằng cách nhấn vào &ldquo;Kiểm tra ngay&ldquo;, Quý khách đồng ý
                cho phép Home Credit Việt Nam liên hệ với Quý khách qua tin
                nhắn, điện thoại và/ hoặc thư điện tử (dựa trên thông tin do Quý
                khách cung cấp trên đây, và/hoặc thông tin Quý khách đã cung cấp
                khi ký hợp đồng với Home Credit Việt Nam trước đó – đối với
                khách hàng đã từng vay với Home Credit) để giúp/ hướng dẫn Quý
                khách thực hiện/ hoàn thành yêu cầu kiểm tra khả năng duyệt vay
                này, yêu cầu vay và/ hoặc để thông tin đến Quý khách những
                chương trình ưu đãi phù hợp với Quý khách.
              </p>
            </div>
            <Button className={s.btnStart} onClick={this.onToggleOpenPolicy}>
              Tiếp Tục
            </Button>
          </div>
        </Modal>
        {loading && <FullLoadingCycle className={s.loading} />}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  updatePersonalInformation: info => {
    document.cookie = `trackingId=${uuidv4()}`;
    dispatch(updateUserInformation(info));
  },
  bodGenerateOTP: (phoneNumber, token) =>
    dispatch(generateOTP(phoneNumber, token)),
  toggleAlert: message => dispatch(showErrorNotification(message, true)),
});

const mapStateToProps = ({ clz: { newBOD } }) => ({
  newBOD,
});

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withFormik({
    mapPropsToValues: () => initialValue,
    validationSchema: informationValidation,
  }),
  withStyles(s),
);

export default enhance(PersonalInformation);
